import { Container, Text } from '@audio-network/componentlibrary'
import Download from '@/components/shared/Download'
import DownloadUnavailable from '@/components/shared/DownloadUnavailable/DownloadUnavailable'
import { PlaylistInfoProps } from './PlaylistInfo.types'
import React from 'react'
import isDateWithinFortnight from '@/utils/isDateWithinFortnight'
import styles from './PlaylistInfo.module.css'
import { useTranslation } from 'next-i18next'

const PlaylistInfo = ({
	playlist,
	tracks,
	isCatalogueAvailable,
	...props
}: PlaylistInfoProps): JSX.Element => {
	const { t } = useTranslation(['playlist'])

	return (
		<section {...props}>
			<Container maxWidth="large" className={styles.trackListInformation}>
				<div>
					<Text display="block" variant="headingS" uppercase>
						{t('track-count', { number: tracks.length })}
					</Text>
					{isDateWithinFortnight(playlist.sys.publishedAt as Date) && (
						<Text display="block">{t('recently-updated')}</Text>
					)}
				</div>
				{isCatalogueAvailable ? (
					<Download
						downloadName={playlist.title}
						downloadText={t('download-all-primary')}
						downloadOptions={t('download-all-options')}
						downloadOptionWav={t('download-all-option-wav')}
						downloadOptionMp3={t('download-all-option-mp3')}
						tracks={tracks}
						trackSource="Playlist"
					/>
				) : (
					<DownloadUnavailable />
				)}
			</Container>
		</section>
	)
}

export default PlaylistInfo
